import { cn } from "@/lib/utils";

export default function DirectionsIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3.5 text-white", className)}
      fill="inherit"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.0396 8.43816C0.581025 7.98357 0.349743 7.525 0.345755 7.06243C0.341768 6.59588 0.567069 6.13331 1.02166 5.67474L5.84869 0.85369C6.30328 0.3991 6.76185 0.173799 7.22442 0.177786C7.69097 0.181774 8.15354 0.413057 8.61211 0.871634L13.4092 5.66875C13.8678 6.12733 14.0971 6.5899 14.0971 7.05645C14.1011 7.523 13.8758 7.98158 13.4212 8.43218L8.60015 13.2592C8.14556 13.7098 7.68499 13.9331 7.21844 13.9291C6.75587 13.9291 6.2953 13.6998 5.83672 13.2413L1.0396 8.43816ZM4.53277 8.69536C4.53277 8.89076 4.58261 9.04628 4.6823 9.16192C4.78199 9.27357 4.91957 9.3294 5.09502 9.3294C5.27447 9.32541 5.41403 9.26759 5.51372 9.15594C5.61342 9.04428 5.66326 8.89076 5.66326 8.69536V7.34356C5.66326 7.10031 5.72307 6.91888 5.8427 6.79925C5.96233 6.67563 6.13779 6.61382 6.36907 6.61382H7.96612V7.39141C7.96612 7.60275 8.04986 7.74432 8.21734 7.81609C8.38482 7.88388 8.5523 7.85198 8.71978 7.72039L10.2391 6.53008C10.4265 6.37855 10.5182 6.21506 10.5142 6.0396C10.5142 5.86415 10.4225 5.70265 10.2391 5.55511L8.71978 4.3648C8.5523 4.23321 8.38482 4.2033 8.21734 4.27508C8.04986 4.34287 7.96612 4.48044 7.96612 4.6878V5.47735H6.24346C5.66924 5.47735 5.24057 5.61891 4.95745 5.90203C4.67433 6.18515 4.53277 6.61183 4.53277 7.18206V8.69536Z"
        fill="currentColor"
      />
    </svg>
  );
}
